import React, {
  ReactNode,
} from 'react';
import clsx from 'clsx';

type Part = 'root' | 'content' | 'overlay' | 'line';

type Props = {
  active: boolean;
  children: ReactNode;
  classes?: Partial<Record<Part, string>>;
};

const ROOT_CLASSES = 'relative overflow-hidden';
const CONTENT_CLASSES = 'relative z-0';
const OVERLAY_CLASSES = 'pointer-events-none absolute inset-0 z-10 bg-[#378ADD]/5';
const LINE_CLASSES = 'scan-overlay-line pointer-events-none absolute inset-x-0 top-0 z-20 h-0.5 bg-[linear-gradient(90deg,transparent,rgba(55,138,221,0.24),rgba(55,138,221,1),rgba(55,138,221,0.24),transparent)]';

export default function ScanOverlay({
  active,
  children,
  classes,
}: Props) {
  return (
    <div className={clsx(ROOT_CLASSES, classes?.root)}>
      <div className={clsx(CONTENT_CLASSES, classes?.content)}>
        {children}
      </div>
      {active && (
        <>
          <div className={clsx(OVERLAY_CLASSES, classes?.overlay)} />
          <div className={clsx(LINE_CLASSES, classes?.line)} />
        </>
      )}
    </div>
  );
}
